RivalIQ.apps.Admin.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    apps.Query = window.createMarionetteApp();
    apps.Query.name = 'Query';

    apps.Query.defaultQueryName = 'New Dataclip';
    apps.Query.defaultQueryText = '-- put SQL here';

});
